// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__3x-Hd","tab":"Tabs_tab__3pfjb","tabActive":"Tabs_tabActive__2T0Oi"};